export default __webpack_public_path__ + "static/media/googleLogo.9f4ad142.svg";